import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import { jqTextExpander, jqTextCopy } from 'javascripts/general_scripts';
import { comparisonWidget } from "javascripts/product_comparisons/comparison_widget";
import('javascripts/comments');

jqTextExpander();
jqTextCopy();
comparisonWidget();